<script setup>
/* eslint-disable */
import { onMounted, onUnmounted, watch, ref, computed } from 'vue';
import { useSocketStore } from '@/stores/socket';
import { usePreSportsStore } from '@/stores/pre_sports';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useMarketsStore } from '@/stores/markets';
import { useGeneralStore } from '@/stores/general';
import { useRouter, useRoute } from 'vue-router';
import { useSportPopularStore } from '@/stores/sport_popular';
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

import PreSportFeaturedFixtures from '@/components/pre_sports/PreSportFeaturedFixtures.vue';
import LiveOverview from '@/components/pre_sports/highlights/LiveOverview.vue';
import UpcomingOverview from '@/components/pre_sports/highlights/UpcomingOverview.vue';
import PopularOverview from '@/components/pre_sports/highlights/PopularOverview.vue';
import HighlightsFixtureContainer from '@/components/pre_sports/highlights/HighlightsFixtureContainer.vue';
import FixtureOrderSelector from '@/components/pre_sports/highlights/FixtureOrderSelector.vue';
import { useI18n } from 'vue-i18n';
import { SportsData } from '@/stores/Sports';
import { useFavouritesStore } from '@/stores/favourites';

import BetBoosterComponent from '@/components/Common/BetBooster/BetBoosterComponent.vue';

const socketStore = useSocketStore();
const preSportsStore = usePreSportsStore();
const liveSportsStore = useLiveSportsStore();
const marketsStore = useMarketsStore();
const liveSportOverviewStore = useLiveSportOverview();
const generalStore = useGeneralStore();
const sportPopularStore = useSportPopularStore();
const SportsDataStore = SportsData();
const favouritesStore = useFavouritesStore();
const platformConfigurationStore = usePlatformConfigurationStore();

const router = useRouter();
const route = useRoute();

const { t } = useI18n();

const active_tab = ref(platformConfigurationStore.isNewPreSportsDesignEnabled ? 'todays' : 'upcoming');

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const show_scroll_to_top_button = ref(false);

const selected_fixture_order = ref('popular');

const changeTab = (tab) => {
	active_tab.value = tab;
}

watch(() => liveSportOverviewStore.overviewFixturesCount, (newVal) => {
	if (active_tab.value == 'live' && newVal == 0) {
		active_tab.value = 'upcoming';
	}
});

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}

const props = defineProps({
	primary_overview_market: {
		type: Object,
		required: true,
	},
});

onMounted(() => {
	if (router.currentRoute.value.params.sport_id != '') {
		let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (selected_pre_sport) document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.highlights');

		let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
		if (sport_overview_markets) {

			if (sport_overview_markets.length > 1) {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[1];
			} else {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[0]
			}
		}

		socketStore.join('sportHighlights', router.currentRoute.value.params.sport_id);
		socketStore.join('liveSportOverview', router.currentRoute.value.params.sport_id);
	}

	window.addEventListener('scroll', handleScroll);

})

onUnmounted( () => {
	socketStore.leave('sportHighlights', preSportsStore.selected_pre_sport_id);
	socketStore.leave('liveSportOverview');
	liveSportOverviewStore.emptyLiveSportsOverview();
})

watch(() => preSportsStore.preSports, (newSports, oldSports) => {
	if (oldSports.length == 0 && newSports.length > 0) {
		let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
		if (!selected_pre_sport) return;
		document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.highlights');
	}
})

watch(() => marketsStore.overview_markets, (newValue) => {
	if (!newValue) return;
	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];

		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}
});

const scrollToTop = () => {
	window.scrollTo({ top: 0 });
};

watch(route, (to, from) => {
	if (!to.params.hasOwnProperty('sport_id') || to.params.sport_id == '') return;

	socketStore.join('sportHighlights', to.params.sport_id);
	socketStore.join('liveSportOverview', to.params.sport_id);

	let sport_overview_markets = marketsStore.sportOverviewMarkets(router.currentRoute.value.params.sport_id);
	if (sport_overview_markets.length > 1) {
		primary_overview_market.value = sport_overview_markets[0];

		secondary_overview_market.value = sport_overview_markets[1]
	} else {
		primary_overview_market.value = sport_overview_markets[0];
		secondary_overview_market.value = sport_overview_markets[0]
	}

	let selected_pre_sport = _.find(preSportsStore.preSports, {'id': Number(router.currentRoute.value.params.sport_id) });
	document.title = generalStore.getGeneral.site_name + ' - ' + selected_pre_sport.name + ' ' + t('general.highlights');

});
</script>

<template>
		<template v-if="!platformConfigurationStore.showOnlyFixturesOnHighlights">
			<PreSportFeaturedFixtures v-if="sportPopularStore.getTopFeaturedFixtures.length > 0"/>

			<BetBoosterComponent v-if="platformConfigurationStore.isBetBoostHighlightWidgetEnabled" :show_title="true" :title="$t('bet_boost.title')" :selected_sport_id="preSportsStore.selected_pre_sport_id" :formated_title="true"></BetBoosterComponent>
		</template>
		<div class="live-bet-dashboard round-games-main set_game-outer">
		<div class="bet-dashboard-top">
			<div class="tabing-dashboard">
				<div class="tab-pills">
					<template v-if="platformConfigurationStore.isNewPreSportsDesignEnabled">
						<button class="tab-link" :class="active_tab == 'todays' ? 'active' : ''" data-tab-id="todays" @click="changeTab('todays')">{{$t('days.today')}}</button>
						<button class="tab-link" :class="active_tab == '48_hours' ? 'active' : ''" data-tab-id="48_hours" @click="changeTab('48_hours')">{{$t('day_time_selector.next_48_hours')}}</button>
					</template>
					<template v-else>
						<button class="tab-link" :class="active_tab == 'upcoming' ? 'active' : ''" data-tab-id="upcoming" @click="changeTab('upcoming')">{{$t('general.upcoming')}}</button>
						<button v-if="sportPopularStore.getTopFeaturedFixtures.length > 0" class="tab-link" :class="active_tab == 'popular' ? 'active' : ''" data-tab-id="popular" @click="changeTab('popular')">{{$t('general.popular')}}</button>
					</template>

					<!-- <button class="tab-link" :class="active_tab == 'upcoming' ? 'active' : ''" data-tab-id="upcoming" @click="changeTab('upcoming')">{{$t('general.upcoming')}}</button> -->
					<!-- <button v-if="sportPopularStore.getTopFeaturedFixtures.length > 0" class="tab-link" :class="active_tab == 'popular' ? 'active' : ''" data-tab-id="popular" @click="changeTab('popular')">{{$t('general.popular')}}</button> -->
					<button v-if="liveSportOverviewStore.overviewFixturesCount > 0" class="tab-link last-btn" :class="active_tab == 'live' ? 'active' : ''" data-tab-id="live" @click="changeTab('live')">{{ $t('general.live') }} ({{ liveSportOverviewStore.overviewFixturesCount }})</button>
				</div>
			</div>
			<div class="dashboard-info-label bet-tab-title" >
				<h3 v-if="active_tab == 'upcoming'">{{ $t('general.upcoming') }}</h3>
				<h3 v-if="active_tab == 'popular'">{{ $t('general.popular') }}</h3>
				<h3 v-if="active_tab == 'live'">{{ $t('general.live') }} ({{ liveSportOverviewStore.overviewFixturesCount }})</h3>
			</div>
			<div class="dashboard-info-label dropdown-option-top" v-if="primary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_primary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
						<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
							<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_primary_overview_market = !show_primary_overview_market"  v-click-outside-element="closePrimaryOverviewMarketSelector">{{ primary_overview_market?.name?.toUpperCase() }}</button>
						</dt>
						<dd>
							<ul>
								<li v-for="overview_market in marketsStore.sportOverviewMarkets(preSportsStore.selected_pre_sport_id)" :key="overview_market.slug" @click="selectPrimaryOverviewMarket(overview_market)" :class="primary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
									<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market?.name?.toUpperCase() }}</button>
									<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(preSportsStore.selected_pre_sport_id, overview_market)">
										<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
											<path :style="{ fill: favouritesStore.isOverviewFavourite(preSportsStore.selected_pre_sport_id, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
										</svg>
									</div>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>

			<div class="dashboard-info-label dropdown-option-top dropdown-option-top-2" v-if="secondary_overview_market">
				<div class="select-option">
					<dl class="drop" :class="show_secondary_overview_market ? 'active' : ''">
						<span class="tabIco">
							<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
								<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
									<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
								</g>
							</svg>
						</span>
						<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
							<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_secondary_overview_market = !show_secondary_overview_market"  v-click-outside-element="closeSecondaryOverviewMarketSelector">{{ secondary_overview_market?.name?.toUpperCase() }}</button>
						</dt>
						<dd>
							<ul>
								<li v-for="overview_market in marketsStore.sportOverviewMarkets(preSportsStore.selected_pre_sport_id)" :key="overview_market.slug" @click="selectSecondaryOverviewMarket(overview_market)" :class="secondary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
									<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market?.name?.toUpperCase() }}</button>
									<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(preSportsStore.selected_pre_sport_id, overview_market)">
										<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
											<path :style="{ fill: favouritesStore.isOverviewFavourite(preSportsStore.selected_pre_sport_id, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
										</svg>
									</div>
								</li>
							</ul>
						</dd>
					</dl>
				</div>
			</div>


			<FixtureOrderSelector  v-if="platformConfigurationStore.isNewPreSportsDesignEnabled" v-model="selected_fixture_order" />

			<div class="mobile-odds-heading">
				<div class="mobile-odds-heading-inner">
					<template v-for="(odd, id) in primary_overview_market?.odd_names" :key="id">
							<span v-if="odd != ''">{{ odd }}</span>
					</template>
				</div>

			</div>
		</div>

		<div class="live-tab-info" id="tabs">
			<LiveOverview v-if="active_tab == 'live'" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>


			<template v-if="platformConfigurationStore.isNewPreSportsDesignEnabled">

				<HighlightsFixtureContainer v-if="active_tab == 'todays' && preSportsStore.selected_pre_sport_id"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:sport_id="preSportsStore.selected_pre_sport_id"
					:time="'today'"
					:fixture_order="selected_fixture_order"
					:pre_only="true"
				/>

				<HighlightsFixtureContainer v-if="active_tab == '48_hours' && preSportsStore.selected_pre_sport_id"
					:primary_overview_market="primary_overview_market"
					:secondary_overview_market="secondary_overview_market"
					:sport_id="preSportsStore.selected_pre_sport_id"
					:time="'48_hours'"
					:fixture_order="selected_fixture_order"
					:pre_only="true"
				/>

			</template>
			<template v-else>
				<UpcomingOverview v-if="active_tab == 'upcoming'" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>
			</template>

			<PopularOverview v-if="active_tab == 'popular'" :primary_overview_market="primary_overview_market" :secondary_overview_market="secondary_overview_market"/>
		</div>
	</div>
	<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button">
		<i class="fas fa-arrow-up"></i>
	</button>
</template>
<style scoped>
.live-bet-dashboard .dashboard-info-label .select-option .drop dd ul{
	min-width: 120px;
}
.live-bet-dashboard.round-games-main .bet-dashboard-top{
	grid-template-columns: 38% 25% 20% 12%;
}
.live-bet-dashboard.round-games-main .bet-dashboard-top:after {
	width: 100% !important;
}
@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	color: var(--buttons-text-color);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}
@media screen and (min-width: 768px) {
	.tab-pills {
		padding-bottom: 12px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	.dropdown-option-top-2 {
		display: none;
	}
}
@media screen and (min-width: 320px) and (max-width: 323px) {
	.last-btn {
		margin-top: 5px;
	}
}

html[dir="rtl"] .live-bet-dashboard .bet-dashboard-top:after {
	right: unset;
	left: 0px;
}

.live-tab-info {
	scrollbar-width: none !important;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	.live-tab-info {
		min-height: unset;
		max-height: unset;
		height: unset;
	}
}

</style>